import { defineBoot } from '@quasar/app-vite/wrappers';
import storage from 'src/services/storage';
import store from 'src/store';

/**
 * Initialize storage service.
 *
 * @param {Object} params
 * @param {RootStore} params.store
 */
export default defineBoot(() => {
  storage.setStore(store());
});
